import { Button, Stack } from '@mui/material';
import { EnhancedTable, TableHeadCell } from 'components';
import * as React from 'react';
import { useState } from 'react';

interface Props<T extends { [key: string]: any }> {
    title: string;
    onProcessUploadedData: (data: T[]) => void;
}

export function BulkUploadJson<T extends { [key: string]: any }>(props: Props<T>) {
    const [filesData, setFiles] = useState<T[]>([]);

    const onFileUpload: React.ChangeEventHandler<HTMLInputElement> = (e) => {
        const fileReader = new FileReader();
        if (e.target.files) {
            fileReader.readAsText(e.target.files[0], 'UTF-8');
            fileReader.onload = (e) => {
                try {
                    setFiles(JSON.parse(e.target!.result!.toString()));
                } catch (error: any) {
                    alert('Unable to parse file JSON data. ' + JSON.stringify(error));
                }
            };
        }
    };

    const defineHeadCells = (): TableHeadCell<T>[] => {
        if(filesData.length) {
            return Object.keys(filesData[0]).map<TableHeadCell<T>>(key => ({
                disablePadding: false,
                id: key as (keyof T),
                label: key
            }))
        }
        return [];
    };

    const getIdKey = (): keyof T => {
        if(filesData.length) {
            return Object.keys(filesData[0])[0];
        }
        return "id";
    };

    const onProcessData = () => {
        props.onProcessUploadedData(filesData);
        onClearData();
    }

    const onClearData = () => {
        setFiles([]);
    }

    return (
        <div style={{display: 'flex', flexGrow: 1, flexDirection: 'column'}}>
            <div className='upload-questions-btn-wrapper'>
                <label htmlFor="input-file-upload">Upload JSON file</label>
                <input type="file" id="input-file-upload" value="" onChange={onFileUpload} accept=".json" />
            </div>
            
            {!!filesData.length && (
                <>
                    <EnhancedTable<T>
                        title={props.title}
                        data={filesData}
                        headerCells={defineHeadCells()}
                        dataRecordIdKey={getIdKey()}
                        showTableCheckboxes={true}
                    />
                    <Stack spacing={2} direction="row">
                        <Button variant="contained" onClick={onProcessData}>
                            Process data
                        </Button>
                        <Button variant="contained" onClick={onClearData}>
                            Clear uploaded data
                        </Button>
                    </Stack>
                </>
            )}
        </div>
    );
}
